import { put, takeEvery, call, takeLatest } from "redux-saga/effects";
import { commonConstants, reportsConstants } from "../../constants";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { reports, alertActions } from "../../actions";

function* listing(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.reportsUrl.standard,
      action.payload
    );

    if (data === true) {
      yield put(
        reports.listingSuccess()
      );
    } else if(data.status === true) {
      yield put(
        reports.listingSuccess()
      );
      yield put(alertActions.success(data.message));
    } else {
      yield put(alertActions.error("Please try again later"));
    }
  } catch (error) {
  }
}

function* configListing(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.reportsUrl.configUrl.list,
      action.payload
    );

    if (data.status === true) {
      let totalRecords =
        (data.data &&
          data.data.pagination_options &&
          data.data.pagination_options.total_count) ||
        0;
      let totalpages = Math.ceil(
        parseInt(totalRecords) / commonConstants.recordsPerPage
      );

      yield put(
        reports.configListingSuccess({
          list: data.data && data.data.list,
          paginationOptions: {
            totalpages,
            currentpage: action.payload.page,
            totalRecords,
            limit_per_page: commonConstants.recordsPerPage
          }
        })
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

function* configSave(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.reportsUrl.configUrl.save,
      action.payload
    );

    if (data.status === true) {
      yield put(alertActions.success(data.message));
      yield put(
        reports.configSaveSuccess()
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

function* configDelete(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.reportsUrl.configUrl.delete,
      action.payload
    );

    if (data.status === true) {
      yield put(alertActions.success(data.message));
      yield put(
        reports.configDeleteSuccess()
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

export function* reportsSaga() {
  yield takeLatest(reportsConstants.LISTING_REQUEST, listing);
  yield takeLatest(reportsConstants.CONFIG_LISTING_REQUEST, configListing);
  yield takeEvery(reportsConstants.CONFIG_SAVE_REQUEST, configSave);
  yield takeEvery(reportsConstants.CONFIG_DELETE_REQUEST, configDelete);
}
